<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Cancelas">
          <listar-cancela />
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListarCancela from '@/components/patio/ListarCancela'
export default {
  data() {
    return {
      page: {
        title: 'Gerenciamento de cancelas',
      },
      breadcrumbs: [
        {
          text: 'Cancelas',
          disabled: false,
          to: '/patio/patio',
        },
        {
          text: 'Cancelas',
          disabled: false,
        },
      ],
    }
  },
  components: {
    ListarCancela,
  },
}
</script>

<style></style>
